import React from 'react'
import PropTypes from 'prop-types'

const TextWithDots = ({ children, as: Component, ...props }) => (
  <Component {...props}>
    {children.split(' ').map((word, idx) => (
      <span
        key={`${word}-${idx}`}
        className='after:content-["."] after:text-brand-primary last:after:content-[";"] max-sm:text-3xl'
      >
        {word}
      </span>
    ))}
  </Component>
)

export default TextWithDots

TextWithDots.propTypes = {
  children: PropTypes.string.isRequired,
  as: PropTypes.node
}

TextWithDots.defaultProps = {
  as: 'h2'
}
